import classNames from "classnames";
import React, { useId, useState } from "react";
import arrowDropdownIcon from "../assets/images/arrow-down-thin.svg";
import useTranslations from "../hooks/useTranslations";
import { SanityImageSourceExt } from "../models/shared/SanityImageSourceExt";
import { isNullOrWhiteSpace } from "../shared/string";
import { Collapse } from "./Collapse";
import { Picture } from "./Picture";

interface FormSelectorDropdownProps {
  title?: string;
  children?: React.ReactNode;
  image?: SanityImageSourceExt;
}

export const FormSelectorDropdown = ({
  children,
  title,
  image
}: FormSelectorDropdownProps) => {
  const translations = useTranslations();

  const internalId = useId();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="dropdown flex flex-col w-full card-basic p-8 cursor-pointer">
      <div className="flex items-center gap-6" onClick={() => setIsOpen(!isOpen)}>
        {image && (
          <Picture
            image={image}
            imgClassName="rounded-full"
            presets={{
              default: {
                height: 100,
                width: 100
              }
            }}
          />
        )}

        {!isNullOrWhiteSpace(title) && (
          <p className="font-bold m-0 text-[1.75rem] text-brand-primary-30">{title}</p>
        )}

        <button
          aria-expanded={isOpen}
          aria-controls={internalId}
          aria-label={
            isOpen ? translations.collapse ?? "Collapse" : translations.expand ?? "Expand"
          }
          className={classNames(
            "flex justify-center items-center w-12 h-12 p-3 transition-transform duration-300 ease-in-out ml-auto",
            {
              "transform rotate-180": isOpen
            }
          )}
        >
          <svg width={12} height={12} className="stroke-current">
            <use xlinkHref={arrowDropdownIcon.url} />
          </svg>
        </button>
      </div>

      <Collapse id={internalId} isOpen={isOpen}>
        <div className="px-4 pt-2 pb-8 lg:px-32 lg:py-12 w-full">{children}</div>
      </Collapse>
    </div>
  );
};
